import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { performanceService } from '../../../../api/services/performanceService';
import {
  setEvaluatorData,
  setEvaluatorSheetData,
  setEvaluationId,
  setAnswerId,
  setTempEvaluatorSheetData,
  setEvaluatorLoader,
  setEvaluatorId,
  setQuestionnaireId,
  setTriggerData,
} from '../../../../infra/aggregates/myProfile/EvaluatorData/evaluatorData';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

function DTOTeamReviewModal() {
  const dispatch = useAppDispatch();
  const evaluatorSheetID = useAppSelector(
    (state) => state.evaluatorDetails?.evaluatorSheetId,
  );
  const evaluationId = useAppSelector(
    (state) => state.evaluatorDetails?.evaluationId,
  );
  const evaluatorId = useAppSelector(
    (state) => state.evaluatorDetails?.evaluatorId,
  );
  const trigger = useAppSelector(
    (state) => state.evaluatorDetails?.triggerData,
  );
  const questionnaireId = useAppSelector(
    (state) => state.evaluatorDetails?.questionnaireId,
  );
  const evaluatorUserId = useAppSelector(
    (state) => state.evaluatorDetails?.evaluatorUserId,
  );
  const temp = useAppSelector(
    (state) => state.evaluatorDetails.tempEvaluatorSheetData,
  );
  const data = useAppSelector(
    (state) => state.evaluatorDetails.evaluatorSheetData,
  );
  const user_id = useAppSelector(
    (state) => state.authSlice?.user_id,
  );
  const kpi_id = useAppSelector((state) => state.evaluatorDetails?.kpiId);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    dispatch(setEvaluatorLoader(true));
    getEvaluationSheet(evaluatorSheetID);
    getKpis(kpi_id);
  }, [evaluatorSheetID]);

  useEffect(() => {
    if (evaluationId !== 'undefined' && evaluationId !== '') {
      getEvaluationsById(evaluationId);
    }
  }, [evaluationId]);

  useEffect(() => {
    if (trigger) {
      if (
        evaluatorId !== '' &&
        questionnaireId !== '' &&
        evaluationId !== '' &&
        evaluatorUserId !== 0 &&
        evaluatorUserId == user_id
      ) {
        getEvaluationSheetDataByEvaluatorId(
          evaluationId,
          questionnaireId,
          evaluatorUserId,
          evaluatorId,
        );
      } else {
        toast.error('This sheet is not belongs to you')
      }
    }
  }, [evaluatorId]);

  //GET EvaluationSheet
  async function getEvaluationSheet(id: string) {
    const response: any = await performanceService.getEvaluationSheetById(id);
    if (response.status === 200) {
      dispatch(setEvaluatorSheetData(response?.data));
      dispatch(setEvaluationId(response?.data?.evaluation?.id));
      dispatch(setQuestionnaireId(response?.data?.questionnaire?.id));

      if (response?.data?.answers) {
        dispatch(setAnswerId(response?.data?.answers?.[0]?.id));
      }
    } else {
      toast.error(t(response?.message));
      return;
    }
  }
  //GET User Evaluator
  async function getEvaluationsById(id: string) {
    const response: any = await performanceService.getEvaluatorById(id);
    if (response) {
      dispatch(setEvaluatorData(response));
      dispatch(setEvaluatorId(user_id));
      dispatch(setEvaluatorLoader(false));
    } else {
      toast.error(t(response?.message));
      return;
    }
  }
  //GET EvaluatorSheet for Evaluator
  async function getEvaluationSheetDataByEvaluatorId(
    evaluationId: string,
    questionnaireId: string,
    currentUserId: number,
    id: string,
  ) {
    performanceService
      .getEvaluationSheetByEvaluatorId(
        evaluationId,
        questionnaireId,
        currentUserId,
        id,
      )
      .then((response) => {
        if (response.status === 200){
          dispatch(setTempEvaluatorSheetData(response?.data));
          dispatch(setTriggerData(false))
        }
        else {
          toast.error(t(response?.data?.message || response?.message))
          dispatch(setTriggerData(false))
        }
      })
      .catch((error) => {
        toast.error(t(error?.message));
        dispatch(setTriggerData(false))
        return;
      });
  }
  //GET Questionnaire data by Kpi id
  async function getKpis(kpi_id: string) {
    const response: any = await performanceService.getKpis(kpi_id);
    if (response.status === 200) {
      dispatch(setTempEvaluatorSheetData(response?.data));
    } else {
      toast.error(t(response?.message));
      return;
    }
  }

  return <></>;
}
export default DTOTeamReviewModal;
